import React from 'react';
import { COLORS } from '../constants/gameConstants';
import '../styles/Cell.css';

const Cell = ({ value, row, col, isNew, merged, cellSize, gridGap }) => {
  const color = COLORS[value] || COLORS[2048];

  const cellStyle = {
    backgroundColor: color.background,
    color: color.text,
    width: `${cellSize}px`,
    height: `${cellSize}px`,
    transform: `translate(
      ${col * (cellSize + gridGap) + gridGap}px, 
      ${row * (cellSize + gridGap) + gridGap}px
    )`,
    fontSize: value < 100 ? '2rem' :
      value < 1000 ? '1.8rem' :
        value < 10000 ? '1.5rem' : '1.2rem',
  };

  const classNames = `cell game-cell ${isNew ? 'new-tile' : ''} ${merged ? 'merged-tile' : ''}`;

  return (
    <div className={classNames} style={cellStyle}>
      {value}
    </div>
  );
};

export default Cell;